export const MANAGER_TIMEZONE = "America/Cuiaba";

const UTC_ZONE_TO_IANA: Record<string, string> = {
    "UTC-2": "America/Noronha",
    "UTC-02:00": "America/Noronha",
    "UTC-3": "America/Sao_Paulo",
    "UTC-03:00": "America/Sao_Paulo",
    "UTC-4": MANAGER_TIMEZONE,
    "UTC-04:00": MANAGER_TIMEZONE,
    "UTC-5": "America/Rio_Branco",
    "UTC-05:00": "America/Rio_Branco",
};

const TIMEZONE_ID_TO_IANA: Record<number, string> = {
    1: "America/Noronha",
    2: "America/Sao_Paulo",
    3: MANAGER_TIMEZONE,
    4: "America/Rio_Branco",
};

const isValidIanaTimezone = (timezone: string): boolean => {
    try {
        new Intl.DateTimeFormat("en-US", { timeZone: timezone }).format();
        return true;
    } catch {
        return false;
    }
};

export const getTimezone = (utcZone?: string | number | null): string => {
    if (typeof utcZone === "number") {
        return TIMEZONE_ID_TO_IANA[utcZone] ?? MANAGER_TIMEZONE;
    }

    const normalizedUtcZone = utcZone?.trim();

    if (!normalizedUtcZone) {
        return MANAGER_TIMEZONE;
    }

    const mappedTimezone = UTC_ZONE_TO_IANA[normalizedUtcZone];

    if (mappedTimezone) {
        return mappedTimezone;
    }

    return isValidIanaTimezone(normalizedUtcZone)
        ? normalizedUtcZone
        : MANAGER_TIMEZONE;
};
